import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MessageService } from 'primeng/api';

import { AppConfig } from '../config';
import {
  PatientAvailabilityChangeRequestModel,
  PatientAvailabilityChangeRequestSubmissionModel,
  PatientAvailabilityPortalModel
} from '../../models/patient/patientAvailabilityModel';

@Injectable()
export class PatientAvailabilityService {

  constructor(
    private http: HttpClient,
    private messageService: MessageService) {
  }

  getPatientAvailability(patientID: number): Observable<PatientAvailabilityPortalModel> {
    return this.http.get<PatientAvailabilityPortalModel>(`${AppConfig.settings.apiServer.webApiURL}/PatientAvailability/${patientID}`)
      .pipe(tap(() => { }, error => {
        console.error(error);
        this.messageService.add({ severity: 'error', detail: 'Unable to load availability.' });
      }));
  }

  createAvailabilityRequest(patientID: number, model: PatientAvailabilityChangeRequestSubmissionModel): Observable<PatientAvailabilityChangeRequestModel> {
    return this.http.post<PatientAvailabilityChangeRequestModel>(`${AppConfig.settings.apiServer.webApiURL}/PatientAvailability/${patientID}/requests`, model)
      .pipe(tap(() => { }, error => {
        console.error(error);
        this.messageService.add({ severity: 'error', detail: error?.error?.message || 'Unable to submit availability request.' });
      }));
  }
}
